<script lang="ts">
  export let toastType = 'default';
  export let animationTime = '5s';

  let toastTypes = [
    { format: 'default', bgStyle: 'bg-blue-200', barStyle: 'bg-blue-500' },
    { format: 'success', bgStyle: 'bg-green-200', barStyle: 'bg-green-500' },
    { format: 'warning', bgStyle: 'bg-yellow-200', barStyle: 'bg-yellow-500' },
    { format: 'error', bgStyle: 'bg-red-200', barStyle: 'bg-red-500' },
  ];

  let bgStyle = toastTypes.find((type) => type.format === toastType)?.bgStyle;
  let barStyle = toastTypes.find((type) => type.format === toastType)?.barStyle;
</script>

<div class="{bgStyle} h-1">
  <div
    class="{barStyle} h-1"
    style="animation: toast-progress-animation {animationTime} linear forwards;"
  ></div>
</div>
